import React, { useContext, useEffect, useRef, useState } from "react";
import { lead_status, new_lead_status } from "../../Config/leadStatus";
import AssessmentDataService from "../../services/Assessment";
import { listContext } from "./ListContext";
import { FiSettings } from "react-icons/fi";
import { useDisclosure, useToast } from "@chakra-ui/react";
import DateModal from "../../components/Modals/FilterDateModal";
import { useNavigate } from "react-router-dom";
import { SlCalender } from "react-icons/sl";
import { SetPageSizeAssessmentModal } from "../../components/Modals/SetPageSizeAssessmentModal";
import { AiFillLock, AiFillUnlock } from "react-icons/ai";
import { BsInfoCircleFill } from "react-icons/bs";
import { ClipLoader } from "react-spinners";
import { SingleRowAssessment } from "../../components/List/SingleRowAssessment";
import { MultiSelect } from "react-multi-select-component";
import { SendQuickMessage } from "../../components/Modals/SendQuickMessage";
import { UpdateEhcExpertModal } from "../../components/Modals/UpdateEhcExpertModal";

export const AssessmentList = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const accessControls =
    JSON.parse(localStorage.getItem("logged_in_user_accesscontrols") || "[]") ||
    [];
  const loginUserId = localStorage.getItem("logged_in_user_id") || "";
  const toast = useToast();
  const localFilter =
    localStorage.getItem("assessment-list-filter-content") || "";
  const localSearch =
    localStorage.getItem("assessment-list-search-content") || "";
  const localPagesize = localStorage.getItem(
    "assessment-list-pageSize-content"
  );

  const localFilteredEhcExpert = localStorage.getItem(
    "new-assessment-list-filter-ehc-expert"
  );
  const newlocalFilteredEhcExpert = localFilteredEhcExpert || "";
  const localFilteredDate = localStorage.getItem("assessment-list-filter-date");
  const newLocalFilteredDate = localFilteredDate
    ? JSON.parse(localFilteredDate)
    : { filterType: "", date: "" };
  const newlocalPagesize = localPagesize ? JSON.parse(localPagesize) : 7;

  const [lock, setLock] = useState({
    filterLock: localFilter !== "" ? true : false,
    searchLock: localSearch !== "" ? true : false,
    pageSizeLock: newlocalPagesize !== 7 ? true : false,
    ehcExpertLock: newlocalFilteredEhcExpert !== "" ? true : false,
    filterDateLock: localFilteredDate ? true : false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [syncEHCLoading, setSyncEHCLoading] = useState(false);
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [data, setData] = useState<any>([]);
  const [ehcCount, setEhcCount] = useState<any>(0);
  const [monthlyEhcCount, setMonthlyEhcCount] = useState<any>(0);
  const [ehcExpert, setEhcExpert] = useState(
    accessControls.includes("juniorEhcExpert")
      ? `expert_${loginUserId}`
      : newlocalFilteredEhcExpert
  );
  const [pageSize, setPageSize] = useState(newlocalPagesize);
  const [totalPages, setTotalPages] = useState(0);
  const [totalAssessments, setTotalAssessments] = useState(0);
  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState(localSearch);
  const [filterValue, setFilterValue] = useState(localFilter);
  const [dateValue, setDateValue] = useState(newLocalFilteredDate.date);
  const [dateTypevalue, setDateTypeValue] = useState(
    newLocalFilteredDate.filterType
  );

  const [modal, setModal] = useState("");
  const [isEhcDateSort, setIsEhcDateSort] = useState("true");
  const [assessmentFlags, setAssessmentFlags] = useState<any>([]);
  const hasAutoSyncedRef = useRef(false);

  const flagOptions = [
    { value: "marked_as_urgent", label: "Marked as Urgent" },
    { value: "marked_as_followup", label: "Marked as Follow-up" },
    { value: "hide_booked", label: "Hide Booked" },
    { value: "hide_upcoming_days", label: "Hide Upcoming Days" },
  ];

  const experts = [
    { name: "User1", id: "expert4_tamannarajpal" },
    { name: "User2", id: "expert_mahi" },
    { name: "User3", id: "expert_user3" },
    { name: "User4", id: "expert_navyav" },
    { name: "Prakriti", id: "expert_prakriti" },
    { name: "Jigyasa", id: "expert_jigyasa" },
    { name: "Tania", id: "expert_tania" },
  ];

  const [expertCounts, setExpertCounts] = useState<any>({});

  const { isallChecked, setIsallChecked } = useContext(listContext);
  const [selectedData, setSelectedData] = useState<any>([]);

  const refreshList = (value: boolean) => {
    setIsallChecked(value);
  };

  const handleSelectedData = (id: string, isChecked: boolean, value: any) => {
    setSelectedData((prevData: any) => {
      if (isChecked) {
        return [...prevData, value];
      } else {
        return prevData.filter((el: any) => {
          return el.id !== id;
        });
      }
    });
  };

  const handleSearchInputChange = (e: any) => {
    setSearchValue(e.target.value);
  };

  const isAssessmentdelete = (isdelete: true) => {
    fetchData();
  };

  const handlePageSize = (input: number, islock: boolean) => {
    setLock({ ...lock, pageSizeLock: islock });
    setPageSize(input);
  };

  const fetchData = () => {
    setIsLoading(true);
    AssessmentDataService.getData(
      filterValue,
      searchValue,
      dateValue,
      dateTypevalue,
      page,
      pageSize,
      isEhcDateSort,
      ehcExpert,
      JSON.stringify(assessmentFlags),
      token
    )
      .then((res) => {
        const data = res.data;
        setData(data.assessments);
        setEhcCount(data.todayEHC);
        setMonthlyEhcCount(data.monthCount);
        setTotalAssessments(data.totalAssessments);
        setTotalPages(data.totalPages);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        if (e.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(e);
      });
  };
  const syncEHCs = (showSuccessToast = true) => {
    setSyncEHCLoading(true);
    AssessmentDataService.syncEHC("50")
      .then((res) => {
        setSyncEHCLoading(false);
        fetchData();
        if (showSuccessToast) {
          toast({
            position: "top",
            title: "EHCs Updated Successfully.",
            // description: "EHCs are updated successfully.",
            status: "success",
            duration: 1000,
            isClosable: true,
          });
        }
      })
      .catch((e) => {
        setIsLoading(false);
        if (e.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
        }
        console.log(e);
      });
  };

  const getFilteredDate = (
    date: string,
    dateType: string,
    lockValue: boolean
  ) => {
    setDateValue(date);
    setDateTypeValue(dateType);
    setLock({ ...lock, filterDateLock: lockValue });
  };

  useEffect(() => {
    fetchData();
  }, [page, pageSize, dateValue]);

  useEffect(() => {
    if (hasAutoSyncedRef.current) {
      return;
    }
    hasAutoSyncedRef.current = true;
    syncEHCs(false);
  }, []);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    const dateType = "screening_date";

    const fetchCounts = async () => {
      try {
        const responses = await Promise.all(
          experts.map((expert) =>
            AssessmentDataService.getData(
              filterValue,
              searchValue,
              today,
              dateType,
              page,
              pageSize,
              isEhcDateSort,
              expert.id,
              JSON.stringify(assessmentFlags),
              token
            )
          )
        );

        const counts: any = {};

        responses.forEach((res, index) => {
          const expertName = experts[index].name;
          const count = res.data.totalAssessments;
          counts[expertName] = count;
        });

        setExpertCounts(counts);
      } catch (err) {
        console.error("Failed to fetch expert counts", err);
      }
    };

    fetchCounts();
  }, []);

  // console.log(selectedData, "selectedData in assessment list");

  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">Free Consultation</div>
        <div className=" p-4">
          {/* top section */}

          <div className="top_section_container">
            <div className="top_section_lower_container">
              <div className="nested p-lg-0">
                <div className="btn-group" role="group">
                  <button
                    type="button"
                    className="btn action-btn"
                    onClick={() => {
                      setModal("filterDate");
                      onOpen();
                    }}
                  >
                    <SlCalender style={{ fontSize: "20px", margin: "0 5px" }} />
                  </button>
                  <button
                    type="button"
                    className="btn action-btn"
                    onClick={() => {
                      setModal("setPageSize");
                      onOpen();
                    }}
                  >
                    <FiSettings style={{ fontSize: "20px", margin: "0 5px" }} />
                  </button>
                  <button
                    type="button"
                    className="btn action-btn"
                    onClick={() => {
                      localStorage.setItem("ehc_page", "new");
                      navigate("/freeconsultation/add");
                    }}
                  >
                    Add Free Consultation
                  </button>
                  <button
                    className="btn action-btn"
                    type="button"
                    onClick={() => syncEHCs()}
                  >
                    Sync Free Consultation
                  </button>
                  <div className="sync-ehc">
                    <ClipLoader
                      color="#fdb508"
                      size={20}
                      cssOverride={{
                        visibility: syncEHCLoading ? "visible" : "hidden",
                      }}
                    />
                  </div>
                </div>
              </div>
              {!accessControls.includes("juniorEhcExpert") && (
                <div className="nested p-lg-0 wide-item">
                  <div>
                    <button
                      // className="btn action-btn search-btn"
                      type="button"
                      className={
                        selectedData.length <= 0
                          ? "btn action-btn disabledButton"
                          : "btn action-btn"
                      }
                      disabled={selectedData.length <= 0 ? true : false}
                      onClick={() => {
                        setModal("changeExpert");
                        onOpen();
                      }}
                    >
                      Update Expert
                    </button>
                  </div>
                </div>
              )}
              <div className="nested p-lg-0 pt-6">
                {/* EHC Count */}
                <div className="parent-booking-count pt-5">
                  <div className="info-icon">
                    <BsInfoCircleFill color="#fdb508" fontSize="24px" />
                  </div>
                  <div className="ehc-info-content p-3 bg-light ml-2">
                    <div className="booking-text">
                      EHC scheduled today :{" "}
                      <span className="booking-count">{ehcCount}</span>
                    </div>

                    {!accessControls.includes("juniorEhcExpert") &&
                      experts.map((expert) => (
                        <div className="booking-text" key={expert.name}>
                          EHC scheduled for {expert.name} today :{" "}
                          <span className="booking-count">
                            {expertCounts[expert.name] || 0}
                          </span>
                        </div>
                      ))}

                    <div className="booking-text">
                      EHC we had this month :{" "}
                      <span className="booking-count">{monthlyEhcCount}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="top_section_lower_container">
              <div className="nested p-lg-0">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control search-bar"
                    onChange={handleSearchInputChange}
                    value={searchValue}
                    placeholder="Phone Number or Name"
                  />
                  <div className="input-group-append">
                    <span
                      className="input-group-text action-btn"
                      onClick={() => fetchData()}
                    >
                      Search
                    </span>
                  </div>
                  <div className="input-group-append ">
                    {lock.searchLock ? (
                      <button
                        className="btn action-btn"
                        style={{ backgroundColor: "#308888" }}
                        type="button"
                        onClick={() => {
                          setLock({ ...lock, searchLock: false });
                          setSearchValue("");
                          localStorage.removeItem(
                            "assessment-list-search-content",
                          );
                        }}
                      >
                        <AiFillLock
                          style={{ fontSize: "20px", margin: "0 5px" }}
                        />
                      </button>
                    ) : (
                      <button
                        className="btn action-btn"
                        style={{ backgroundColor: "#308888" }}
                        type="button"
                        onClick={() => {
                          setLock({ ...lock, searchLock: true });
                          localStorage.setItem(
                            "assessment-list-search-content",
                            searchValue,
                          );
                        }}
                      >
                        <AiFillUnlock
                          style={{ fontSize: "20px", margin: "0 5px" }}
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="nested p-lg-0">
                <div className="input-group">
                  <select
                    className="form-control filter-sec"
                    id="lead_status"
                    value={filterValue}
                    onChange={(e) => {
                      setPage(1);
                      setFilterValue(e.target.value);
                      setDateValue("");
                      setDateTypeValue("");
                    }}
                  >
                    {/* <option value="">Please select</option> */}
                    {new_lead_status.map((el) => (
                      <option key={el.data} value={el.value}>
                        {el.data}
                      </option>
                    ))}
                  </select>

                  <div className="input-group-append">
                    <button
                      className="btn action-btn"
                      type="button"
                      // style={{padding:"0 0px"}}
                      onClick={() => {
                        setPage(1);
                        fetchData();
                        setDateValue("");
                        setDateTypeValue("");
                      }}
                    >
                      Search
                    </button>
                  </div>
                  <div className="input-group-append ">
                    {lock.filterLock ? (
                      <button
                        className="btn action-btn"
                        style={{ backgroundColor: "#308888" }}
                        type="button"
                        onClick={() => {
                          setLock({ ...lock, filterLock: false });
                          setFilterValue("");
                          localStorage.removeItem(
                            "assessment-list-filter-content",
                          );
                        }}
                      >
                        <AiFillLock
                          style={{ fontSize: "20px", margin: "0 5px" }}
                        />
                      </button>
                    ) : (
                      <button
                        className="btn action-btn"
                        style={{ backgroundColor: "#308888" }}
                        type="button"
                        onClick={() => {
                          setLock({ ...lock, filterLock: true });
                          localStorage.setItem(
                            "assessment-list-filter-content",
                            filterValue,
                          );
                        }}
                      >
                        <AiFillUnlock
                          style={{ fontSize: "20px", margin: "0 5px" }}
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="top_section_lower_container">
              {!accessControls.includes("juniorEhcExpert") && (
                <div className="nested p-lg-0 ">
                  <div className="input-group">
                    <select
                      className="form-control filter-sec"
                      id="lead_owner"
                      value={ehcExpert}
                      onChange={(e) => {
                        setEhcExpert(e.target.value);
                      }}
                    >
                      <option value="">Select Expert</option>
                      <option value="expert4_tamannarajpal">User1</option>
                      <option value="expert_mahi">User2</option>
                      <option value="expert_user3">User3</option>
                      <option value="expert_navyav">User4</option>
                      <option value="expert_jigyasa">Jigyasa</option>
                      <option value="expert_prakriti">Prakriti</option>
                      <option value="expert_tania">Tania</option>
                    </select>

                    <div className="input-group-append">
                      <button
                        className="btn action-btn"
                        type="button"
                        onClick={() => {
                          fetchData();
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="input-group-append ">
                      {lock.ehcExpertLock ? (
                        <button
                          className="btn action-btn"
                          style={{ backgroundColor: "#308888" }}
                          type="button"
                          onClick={() => {
                            setLock({ ...lock, ehcExpertLock: false });
                            setEhcExpert("");
                            localStorage.removeItem(
                              "new-assessment-list-filter-ehc-expert",
                            );
                          }}
                        >
                          <AiFillLock
                            style={{ fontSize: "20px", margin: "0 5px" }}
                          />
                        </button>
                      ) : (
                        <button
                          className="btn action-btn"
                          style={{ backgroundColor: "#308888" }}
                          type="button"
                          onClick={() => {
                            setLock({ ...lock, ehcExpertLock: true });
                            localStorage.setItem(
                              "new-assessment-list-filter-ehc-expert",
                              ehcExpert,
                            );
                          }}
                        >
                          <AiFillUnlock
                            style={{ fontSize: "20px", margin: "0 5px" }}
                          />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}

              <div className="nested p-lg-0 ">
                <div className="input-group">
                  <div style={{ width: "290px" }}>
                    <MultiSelect
                      options={flagOptions}
                      value={flagOptions.filter((option) =>
                        assessmentFlags.includes(option.value),
                      )}
                      onChange={(selectedOptions: any) => {
                        const values = selectedOptions.map(
                          (opt: any) => opt.value,
                        );
                        setAssessmentFlags(values);
                      }}
                      labelledBy="Select Flags"
                      className="w-100"
                    />
                  </div>

                  <div className="input-group-append">
                    <button
                      className="btn action-btn py-1"
                      type="button"
                      onClick={() => {
                        fetchData();
                      }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {modal === "changeExpert" && (
              <UpdateEhcExpertModal
                isOpen={isOpen}
                onClose={onClose}
                selectedData={selectedData}
                setSelectedData={setSelectedData}
                func={fetchData}
                func1={refreshList}
              />
            )}

            {modal === "filterDate" && (
              <DateModal
                Data={newLocalFilteredDate}
                isLock={lock.filterDateLock}
                isOpen={isOpen}
                onClose={onClose}
                func={getFilteredDate}
              />
            )}
            {modal === "setPageSize" && (
              <SetPageSizeAssessmentModal
                isOpen={isOpen}
                onClose={onClose}
                input={pageSize}
                isLocked={lock.pageSizeLock}
                func={handlePageSize}
              />
            )}
            {/* <div className="col-sm-11 p-lg-0">
             
            </div>
            <div className="col-sm-3 p-lg-0">
              
            </div>
            <div className="col-sm-5 p-lg-0 mt-3">
              
            </div>
            <div className="col-sm-3 p-lg-0">
              
            </div> */}
          </div>

          {/* Main secttion */}
          <div className="main-section">
            <table className="table">
              <thead>
                <tr>
                  {!accessControls.includes("juniorEhcExpert") && (
                    <th>
                      <div className="edit-icon mr-2">
                        <input
                          type="checkbox"
                          checked={isallChecked}
                          aria-label="Checkbox"
                          onChange={(e: any) =>
                            setIsallChecked(e.target.checked)
                          }
                        />
                        Select{" "}
                      </div>
                    </th>
                  )}
                  <th>Edit</th>
                  <th>Mark As</th>
                  <th>Information</th>
                  <th>Expert</th>
                  <th>Lead Personal Info</th>
                  {/* <th>Lead Owner</th> */}
                  <th>Lead Origin</th>
                  <th>Issues</th>
                  <th>Lead Status</th>
                  <th>View Details</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((el: any) => (
                    <SingleRowAssessment
                      key={el.id}
                      props={el}
                      func={isAssessmentdelete}
                      func1={handleSelectedData}
                    />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination section */}
          <div className="row m-0 pagination pt-5">
            <div className="col-sm-6 p-lg-0">
              <p>
                Showing {(page - 1) * pageSize + 1} to{" "}
                {page * pageSize > totalAssessments
                  ? totalAssessments
                  : page * pageSize}{" "}
                of {totalAssessments} entries
              </p>
            </div>
            <div className="col-sm-6 p-lg-0 text-right">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={
                    page === 1
                      ? "btn action-btn disabledButton "
                      : "btn action-btn"
                  }
                  onClick={() => setPage(page - 1)}
                  disabled={page === 1 ? true : false}
                >
                  {"<< Previous"}
                </button>
                <button type="button" className="btn action-btn selected">
                  {page}
                </button>
                <button
                  type="button"
                  className={
                    page === totalPages || totalPages === 0
                      ? "btn action-btn disabledButton "
                      : "btn action-btn"
                  }
                  onClick={() => setPage(page + 1)}
                  disabled={
                    page === totalPages || totalPages === 0 ? true : false
                  }
                >
                  {"Next >>"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
